<select-item [buttonClasses]="'w-100'"
             [fitParent]="true"
             [items]="items"
             [selectedId]="type"
             (selected)="onSelect($event)">
</select-item>
